import React from 'react';

import Config from 'src/lib/config';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { ClickableText } from '../clickableText/ClickableText';

interface Props {
  internalAdminRole: GraphQLTypes.InternalMdgAdminRole;
  accountId: string;
}

export const SuperAdminWarningBanner = ({
  internalAdminRole,
  accountId,
}: Props) => (
  <div className="bg-yellow text-center text-sm leading-loose text-black">
    You are currently viewing the <b>{accountId}</b> org as an administrator (
    {internalAdminRole}).{' '}
    {Config.settings.adminUrl && (
      <>
        [
        <i>
          <ClickableText
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold"
            href={`${Config.settings.adminUrl}/a/${accountId}`}
            as="a"
          >
            admin
          </ClickableText>
        </i>
        ]
      </>
    )}
  </div>
);
